import { useEffect } from "react";
import { useSelector } from "react-redux";

import { syncSentryContext } from "@/observability/sentry";
import useFilterStore from "@/stores/useFilterStore";

const SentryContextSync = () => {
	const user = useSelector((state) => state.auth.user);
	const authFilter = useSelector((state) => state.auth.filter);
	const season = useSelector((state) => state.auth.season);
	const zustandFilter = useFilterStore((state) => state.filter);

	useEffect(() => {
		syncSentryContext({
			user,
			filter: zustandFilter || authFilter,
			season,
		});
	}, [user, authFilter, zustandFilter, season]);

	return null;
};

export default SentryContextSync;
